import apiClient from "./config";

export const getStudyGroups = async () => {
  const response = await apiClient.get("/study-groups");
  return response.data?.data || [];
};

export const createStudyGroup = async (payload) => {
  const response = await apiClient.post("/study-groups", payload);
  return response.data?.data;
};

export const updateStudyGroup = async (groupId, payload) => {
  const response = await apiClient.patch(`/study-groups/${groupId}`, payload);
  return response.data?.data;
};

export const deleteStudyGroup = async (groupId) => {
  const response = await apiClient.delete(`/study-groups/${groupId}`);
  return response.data;
};

export const generateStudyGroupCode = async (groupId) => {
  const response = await apiClient.post(`/study-groups/${groupId}/generate-code`);
  return response.data?.data;
};

export const joinStudyGroupByCode = async (code) => {
  const response = await apiClient.post("/study-groups/join", { code });
  return response.data?.data;
};

export const leaveStudyGroup = async (groupId) => {
  const response = await apiClient.post(`/study-groups/${groupId}/leave`);
  return response.data;
};

export const getStudyGroupMembers = async (groupId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/members`);
  return response.data?.data;
};

export const getAllStudyBuddies = async () => {
  const response = await apiClient.get("/study-groups/buddies");
  return response.data?.data;
};

export const removeStudyGroupMember = async (groupId, memberId) => {
  const response = await apiClient.delete(`/study-groups/${groupId}/members/${memberId}`);
  return response.data;
};

export const removeStudyGroupMembersBatch = async (groupId, memberIds) => {
  const response = await apiClient.post(`/study-groups/${groupId}/members/batch-remove`, { memberIds });
  return response.data;
};

export const getStudyGroupMessages = async (groupId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/hub/messages`);
  return response.data?.data || [];
};

export const sendStudyGroupMessage = async (groupId, payload) => {
  const response = await apiClient.post(`/study-groups/${groupId}/hub/messages`, payload);
  return response.data?.data;
};

export const deleteStudyGroupMessage = async (groupId, messageId) => {
  const response = await apiClient.delete(`/study-groups/${groupId}/hub/messages/${messageId}`);
  return response.data;
};

export const getStudyGroupRequests = async (groupId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/requests`);
  return response.data?.data || [];
};

export const acceptStudyGroupRequest = async (groupId, requestId) => {
  const response = await apiClient.post(`/study-groups/${groupId}/requests/${requestId}/accept`);
  return response.data;
};

export const declineStudyGroupRequest = async (groupId, requestId) => {
  const response = await apiClient.post(`/study-groups/${groupId}/requests/${requestId}/decline`);
  return response.data;
};

export const markStudyGroupChatAsRead = async (groupId) => {
  const response = await apiClient.put(`/study-groups/${groupId}/hub/read`);
  return response.data;
};

export const getGroupReviewerContent = async (groupId, reviewerId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/hub/reviewer/${reviewerId}/content`);
  return response.data;
};

export const inviteStudyGroupMember = async (groupId, payload) => {
  const response = await apiClient.post(`/study-groups/${groupId}/invite`, payload);
  return response.data;
};

// ---------------------------------------------------------------------------
// CHALLENGE MODE APIs
// ---------------------------------------------------------------------------

export const getActiveChallenge = async (groupId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/challenges/active`);
  return response.data?.data;
};

export const createChallenge = async (groupId, payload) => {
  const response = await apiClient.post(`/study-groups/${groupId}/challenges`, payload);
  return response.data?.data;
};

export const submitChallengeAttempt = async (groupId, challengeId, payload) => {
  const response = await apiClient.post(`/study-groups/${groupId}/challenges/${challengeId}/submit`, payload);
  return response.data?.data;
};

export const getChallengeHistory = async (groupId) => {
  const response = await apiClient.get(`/study-groups/${groupId}/challenges/history`);
  return response.data?.data || [];
};

export const cancelChallenge = async (groupId, challengeId) => {
  const response = await apiClient.post(`/study-groups/${groupId}/challenges/${challengeId}/cancel`);
  return response.data;
};
